/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryAddressesDestroyPathAddressIdSchema = z.uuid();

export const deliveryAddressesDestroyStatus204Schema = z.any();

export const deliveryAddressesDestroyResponseSchema = deliveryAddressesDestroyStatus204Schema;
